<script setup>
    // Vue
    import { ref, defineEmits, defineExpose, inject } from 'vue';

    // Store
    import { useAgreementDetailStore } from '@/stores/modal/agreementDetailStore';

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');

    // 親画面から取得したAPIのドメイン部を管理する。
    const API_URL = ref('');

    // ----------------------------
    // 同意済み規定詳細
    // ----------------------------
    const agreementDetailStore = useAgreementDetailStore();

    /**
     * 同意済み規定詳細取得処理
     * @param API_URL
     * @param queryParam
     * @returns なし
     */
    async function getAgreementDetail(API_URL, queryParam) {
        // 規定詳細取得APIをコールする。
        const response = await agreementDetailStore.getAgreementDetailAction(API_URL, queryParam);
        if (!response.success) {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
        }
    }

    // ----------------------------
    // 親側実装必須処理
    // ----------------------------
    const emit = defineEmits(['agreementDetailModal:close']);
    function close() {
        // Storeを初期化する。
        agreementDetailStore.reset();

        // 親画面のモーダル非表示処理を呼び出す
        emit('agreementDetailModal:close');
    }

    /**
     * 親画面から規定詳細モーダルを開くイベントが実行された場合の処理。
     * @param {String} trg HTMLファイルタグが生成されている座標を取得する。
     * @param {String} lang 言語
     * @param {String} regulationPk 規定PK
     * @param {String} regulationHistPk 既定履歴PK
     * @returns なし
     */
    async function openModal(trg, lang, regulationPk, regulationHistPk) {
        // Storeを初期化する。
        agreementDetailStore.reset();

        // APIのURL情報を取得する。
        API_URL.value = trg;

        // 規定詳細取得APIのクエリパラメーターを生成する。
        const queryParam = {
            Lang: lang,
            RegulationPk: regulationPk,
            RegulationHistPk: regulationHistPk,
        };

        // 規定詳細取得APIをコールする。
        await getAgreementDetail(API_URL.value, queryParam);

        // モーダルのHTML要素を取得する。
        const elm1 = document.querySelector('#modalUserTermsDetail .modalContents .regulationBox');

        // モーダルの縦スクロールを先頭に戻す。
        elm1.scrollTop = 0;
    }
    defineExpose({
        openModal,
    });
</script>

<style></style>

<template>
    <article id="modalUserTermsDetail" class="modal" :style="{ display: 'block' }">
        <h3>{{ $t('agreementDetail.parts.modalTitle1') }}</h3>
        <section class="modalContents">
            <div class="regulationBox">
                <span class="regulationDate">{{ agreementDetailStore.RegulationDt }}</span>
                <span class="regulationTitle">{{ agreementDetailStore.RegulationNm }}</span>
                <div class="regulationBody">{{ agreementDetailStore.RegulationContent }}</div>
            </div>
        </section>
        <section class="modalFooter">
            <ul class="btnArea center">
                <li>
                    <!--戻る-->
                    <button type="button" class="btnNormal" @click="close">{{ $t('common.parts.backPage') }}</button>
                </li>
            </ul>
        </section>
    </article>
</template>
